import * as React from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import store, { history } from "./store";
import Routes from "./navigator";
import NavigationMenu from "./drawer";
import { isAuthenticated } from "./auth/auth";
import Snack from "./snack";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { createDatabase } from "./store/db";
import { initializeFirebase } from "./util/pushNotification";

const theme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#41B442",
      contrastText: "#ffffff"
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: "#0066ff",
      main: "#0044ff",
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#ffcc00"
    },
    background: {
      default: "#FCFCFC",
      paper: "white"
    }

    // error: will use the default color
  }
});
class App extends React.Component {
  componentWillMount() {
    createDatabase();
    if (isAuthenticated()) {
      initializeFirebase();
    }
  }
  render() {
    const auth = isAuthenticated();
    return (
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                backgroundColor: "#FCFCFC"
              }}
            >
              <NavigationMenu hasAuth={auth} />
              <Routes />
              <Snack />
            </div>
          </ConnectedRouter>
        </Provider>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx